
import '../../styles/navigation.scss';
const Navigation = () => {
  return (
      <nav>
        <ul>
          <li>
            <a href="Home">Home</a>
          </li>
          <li>
            <a href="#About">About me</a>
          </li>
          <li>
            <a href="#Projects">Portfolio</a>
          </li>
          <li>
            <a href="#">Blog</a>
          </li>

          <li>
            <a href="#Contact">Contact</a>
          </li>
        </ul>
      </nav>
  );
};

export default Navigation;
